function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { axios } from '@repo/http';
import { useQuery } from '@tanstack/react-query';
import { get_org_application_list_path, GET_ORG_APPLICATION_LIST_PATH } from 'ze-api-contract/organization-v2/get-application-list/index';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export const orgAppList = createQueryKeys('organization', {
    applicationList: (param)=>{
        let { organization, perPage, page, queryParams } = param;
        return {
            queryKey: [
                GET_ORG_APPLICATION_LIST_PATH,
                organization,
                page,
                perPage,
                queryParams
            ],
            queryFn: async ()=>{
                if (!organization) {
                    return null;
                }
                const params = _object_spread_props(_object_spread({}, queryParams), {
                    perPage: Number.isInteger(page) ? perPage : undefined
                });
                return axios.get(get_org_application_list_path({
                    organization
                }), {
                    params
                }).then((res)=>res.data);
            }
        };
    }
});
/**
 * Get specific organization application list with pagination.
 *
 * @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md
 */ export function useApplicationList(param) {
    let { organization, queryParams } = param;
    var _ref, _ref1, _ref2;
    var _data_pageMetadata;
    const perPage = (_ref = queryParams === null || queryParams === void 0 ? void 0 : queryParams.perPage) !== null && _ref !== void 0 ? _ref : 7;
    const page = queryParams === null || queryParams === void 0 ? void 0 : queryParams.page;
    const { data, isLoading, error, refetch: applicationListRefetch } = useQuery(orgAppList.applicationList({
        organization,
        perPage,
        page,
        queryParams
    }));
    const applicationList = (_ref1 = data === null || data === void 0 ? void 0 : data.entities) !== null && _ref1 !== void 0 ? _ref1 : [];
    const applicationListCount = (_ref2 = data === null || data === void 0 ? void 0 : (_data_pageMetadata = data.pageMetadata) === null || _data_pageMetadata === void 0 ? void 0 : _data_pageMetadata.lastPage) !== null && _ref2 !== void 0 ? _ref2 : 0;
    return {
        applicationList,
        applicationListCount,
        isLoading,
        error,
        applicationListRefetch
    };
}
